// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgVoiceChat24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 20 18"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path d="M5.77778 18H1.66667C1.22222 18 0.833333 17.85 0.5 17.55C0.166667 17.25 0 16.9 0 16.5V9C0 7.75 0.263889 6.57917 0.791667 5.4875C1.31944 4.39583 2.03241 3.44583 2.93056 2.6375C3.8287 1.82917 4.88426 1.1875 6.09722 0.7125C7.31019 0.2375 8.61111 0 10 0C11.3889 0 12.6898 0.2375 13.9028 0.7125C15.1157 1.1875 16.1713 1.82917 17.0694 2.6375C17.9676 3.44583 18.6806 4.39583 19.2083 5.4875C19.7361 6.57917 20 7.75 20 9V16.5C20 16.9 19.8333 17.25 19.5 17.55C19.1667 17.85 18.7778 18 18.3333 18H14.2222V10.6H18.3333V9C18.3333 6.91072 17.5248 5.13839 15.9078 3.68303C14.2907 2.22768 12.3214 1.5 10 1.5C7.67857 1.5 5.70933 2.22768 4.09225 3.68303C2.4752 5.13839 1.66667 6.91072 1.66667 9V10.6H5.77778V18ZM4.11111 12.1H1.66667V16.5H4.11111V12.1ZM15.8889 12.1V16.5H18.3333V12.1H15.8889Z" />
			</Svg>
		);
	}
);
SvgVoiceChat24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgVoiceChat24;
